/*
 * Public API Surface of ngx-neo-completer
 */

export * from './lib/ngx-neo-completer-mat.module';

export * from './lib/components/completer-cmp';
export * from './lib/components/completer-list-item-cmp';
export * from './lib/directives/ctr-completer';
export * from './lib/directives/ctr-dropdown';
export * from './lib/directives/ctr-input';
export * from './lib/directives/ctr-list';
export * from './lib/directives/ctr-row';
export * from './lib/services/completer-data';
export * from './lib/services/completer-service';
export * from './lib/services/local-data-factory';
export * from './lib/services/remote-data-factory';
export * from './lib/ngx-neo-completer-mat.service';

export {CompleterData} from './lib/services/completer-data';
export {CompleterItem} from './lib/components/completer-item';
export {LocalData} from './lib/services/local-data';
export {RemoteData} from './lib/services/remote-data';
export {CompleterBaseData} from './lib/services/completer-base-data';
